import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { toggleControls } from "redux/actions/flowDesigner/settingsActionCreator";
import ToolboxDetailSubHeader from "../../../ToolboxDetailSubHeader";
import { THEME_COLORS, THEME_TYPES } from "constants/theme";
import { useAuth0 } from "@auth0/auth0-react";
import { updateUserPreferences } from "api/UserApi";



const PreferenceWidgets = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation("flowDesigner");
  const { user } = useAuth0();
  const settings = useSelector((store) => store?.designer?.settings);  
  const isDark = useSelector((store) => store?.portal?.settings.themeMode) === THEME_TYPES.DARK;
  
  const styles = {
    lblSwitcher: {
      position: "relative",
      top: "-1px",
      fontWeight: "normal !important",
      color: `${isDark ? THEME_COLORS.DARK.PRIMARY_FONT : THEME_COLORS.LIGHT.PRIMARY_FONT} !important`
    }
  };

  const switchControls = async () => {
    await updateUserPreferences(user?.cxfUserId, user?.stripeId, {
      designer: {
        ...settings,
        viewOptions: {
          ...settings.viewOptions,
          showControls: !settings.viewOptions.showControls
        }
      }
    });
    dispatch(toggleControls());
  };

  return (
    <>
      <ToolboxDetailSubHeader
        title={t("toolbox.titles.widgets")}
        subtitle={t("toolbox.subtitles.widgets")}
      />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          name="controls"
          label="Canvas Tools"
          sx={{ ...styles.lblSwitcher, marginLeft: 2 }}
          control={
            <Checkbox
              sx={{ marginTop: "0 !important" }}
              checked={settings.viewOptions.showControls}
              onChange={switchControls}
              className="flow-designer-cbx"
            />
          }
        />
      </Box>
    </>
  );
};

export default PreferenceWidgets;
